import React from "react";
import Emote from "../../components/Emotes/Emote";
import style from "./Confetti.module.scss";

interface ConfettiProps {
  emoteSrc: string;
}

const Confetti: React.FC<ConfettiProps> = ({ emoteSrc }) => {
  return (
    <div className={style.confetti}>
      <Emote src={emoteSrc} isEnormous={true} />
    </div>
  );
};

export default Confetti;
